import { isAndroid, isMobileApp } from "helpers/deviceType";
import { logger } from "logging";
import packageJson from "../../../package.json";

/**
 * @description get the app version for react application.
 */
export const getReactAppVersion = () => packageJson.version || "1.0.0";

/**
 * @description get the app version for all  devices.
 */
export const getAppVersion = () => {
  try {
    const isApp = isMobileApp();
    let appVersion = "1.0.0";

    // Setting the app version for msite and desktop.
    if (!isApp) {
      appVersion = getReactAppVersion();
    }

    // Setting the app version for webview.
    if (isApp) {
      let regex = /nykaa-ios-version:(\d+\.\d+\.\d+)/i;
      if (isAndroid()) {
        regex = /nykaa-android-version:(\d+\.\d+\.\d+)/i;
      }
      let userAgent = navigator.userAgent || navigator.vendor || window.opera;
      appVersion = userAgent.match(regex)[1];
    }
    return appVersion;
  } catch (e) {
    logger.error(e, "Error in getting the app version");
    return "";
  }
};
